<div class="col-12 col-sm-11 col-md-11 col-lg-9 col-xl-9 col-xxl-9">
    <c11n-modal-dialog
        [variant]="'warning'"
        [headingText]="grantorContent?.add_user?.frmcSelectAccessLevel?.wrnSelectAccessOnlineTrasactionsNotAvailable.heading"
        [primaryButtonLabel]="grantorContent?.add_user?.frmcSelectAccessLevel?.wrnSelectAccessOnlineTrasactionsNotAvailable?.navContinue"
        [secondaryButtonLabel]="grantorContent?.add_user?.frmcSelectAccessLevel?.wrnSelectAccessOnlineTrasactionsNotAvailable?.navBack"
        (primaryClick)="onContinueModal()"
        [maxWidth]="660"
        [useContentWidth]="false"
        #selectAccessModalDialogue>
        <div c11n-modal-dialog-body>
            <div class="c11n-text-md c11n-space-stack-2x" data-cy="accessModal"
                [innerHTML]="
                    grantorContent?.add_user?.frmcSelectAccessLevel?.wrnSelectAccessOnlineTrasactionsNotAvailable?.text1
                        | replaceParam: 'accessLevelAccess':'limited'
                ">
            </div>
        </div>
    </c11n-modal-dialog>
    <c11n-modal-dialog
        [variant]="'warning'"
        [headingText]="grantorContent?.add_user?.frmcSelectAccessLevel?.wrnInfoOnlyAccNumberVisible?.heading"
        [primaryButtonLabel]="grantorContent?.add_user?.frmcSelectAccessLevel?.wrnInfoOnlyAccNumberVisible?.navContinue"
        [secondaryButtonLabel]="grantorContent?.add_user?.frmcSelectAccessLevel?.wrnInfoOnlyAccNumberVisible?.navBack"
        (primaryClick)="onContinueModal()"
        [maxWidth]="660"
        [useContentWidth]="false"
        #cashPlusModalDialogue>
        <div c11n-modal-dialog-body>
            <div class="c11n-text-md c11n-space-stack-2x" data-cy="accessModal" [innerHTML]="grantorContent?.add_user?.frmcSelectAccessLevel?.wrnInfoOnlyAccNumberVisible?.text1">
            </div>
        </div>
    </c11n-modal-dialog>
    <h1 class="c11n-text-xl-headline c11n-space-stack-6x">{{ grantorContent?.add_user?.frmcSelectAccessLevel?.heading }}</h1>
    <zci-access-level-tile
        [data]="infoOnlyTileData"
        (click)="selectInfoOnlyAndNavigate()">
    >
    </zci-access-level-tile>
    <zci-access-level-tile
        [data]="limitedTileData"
        (click)="selectLimitedAndNavigate()">
    >
    </zci-access-level-tile>
    <zci-access-level-tile
        [data]="fullAuthorityTileData"
        (click)="navigateToForm()">
    >
    </zci-access-level-tile>
</div>



